import { Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

export default function DateRangeSelect({ dateRange, onFilterChange }) {
  const handleStartDateChange = (newValue) => {
    onFilterChange({
      startDate: newValue ? newValue.format("YYYY-MM-DD") : null,
      endDate: dateRange?.endDate || null,
    });
  };

  const handleEndDateChange = (newValue) => {
    onFilterChange({
      startDate: dateRange?.startDate || null,
      endDate: newValue ? newValue.format("YYYY-MM-DD") : null,
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack spacing={2} sx={{ mt: 2 }}>
        <DatePicker
          label="Start Date"
          value={dateRange?.startDate ? dayjs(dateRange.startDate) : null}
          onChange={handleStartDateChange}
          slotProps={{ textField: { size: "small", fullWidth: true } }}
        />

        <DatePicker
          label="End Date"
          value={dateRange?.endDate ? dayjs(dateRange.endDate) : null}
          onChange={handleEndDateChange}
          minDate={
            dateRange?.startDate ? dayjs(dateRange.startDate) : undefined
          }
          slotProps={{ textField: { size: "small", fullWidth: true } }}
        />
      </Stack>
    </LocalizationProvider>
  );
}
